import  { useState, useEffect } from "react";

export function useMediaQuery(query) {
  const [matches, setMatches] = useState( window.matchMedia(query));

  useEffect(() => {
    const media = window.matchMedia(query);

    const checkMatches = () => {
      setMatches(media.matches);
    };

    checkMatches(); // Initial check

    const listener = () => {
      checkMatches();
    };

    if (typeof media.addEventListener === "function") {
      media.addEventListener("change", listener);
    } else {
      media.addListener(listener);
    }

    return () => {
      if (typeof media.removeEventListener === "function") {
        media.removeEventListener("change", listener);
      } else {
        media.removeListener(listener);
      }
    };
  }, [query]);

  return matches;
}
